module.exports = __webpack_public_path__ + "static/media/2.6fef3be5.svg";